



















import { Vue, Component } from "@/shared/vuepack";
import { useUsStateStore } from "@/shared/store/usState";

@Component
export default class StateList extends Vue {

  usStateStore = useUsStateStore();

  mounted (): void {
    this.usStateStore.getStatesFromApi();
  }

  get isLoaded () {
    return this.usStateStore.isStatesLoaded;
  }

  get states () {
    return this.usStateStore.getUsStates;
  }
}
